import { z } from "zod";

export const RECENT_SIGN_WORDS_KEY = "lexivision:recent-sign-words";
const MAX_RECENT_SIGN_WORDS = 5;

const recentSignWordsSchema = z
  .array(
    z.object({
      code: z.string(),
      title: z.string(),
      ruby: z.string(),
    }),
  )
  .describe("最近見た手話単語（新しい順）");

export type RecentSignWord = z.infer<typeof recentSignWordsSchema>[number];

/** 最近見た手話単語を新しい順に返す。保存データが壊れていたり使えなければ空配列 */
export const getRecentSignWords = (): RecentSignWord[] => {
  try {
    const raw = localStorage.getItem(RECENT_SIGN_WORDS_KEY);
    if (raw === null) return [];
    const parsed = recentSignWordsSchema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : [];
  } catch {
    return [];
  }
};

/** 見た単語を先頭に記録する（同じ code は重複させず、最大5件） */
export const saveRecentSignWord = (word: RecentSignWord): void => {
  try {
    const rest = getRecentSignWords().filter((w) => w.code !== word.code);
    const next = [word, ...rest].slice(0, MAX_RECENT_SIGN_WORDS);
    localStorage.setItem(RECENT_SIGN_WORDS_KEY, JSON.stringify(next));
  } catch {
    // 履歴が残らないだけなので、保存の失敗は黙って許容する
  }
};
